<template>
  <div ref="pageRef" class="orderHistory">
    <div class="userInfo">
      <div class="text-weight-bolder font-size-24 text-black">
        <span>Hi, {{ userInfo.nickName }}</span>
      </div>
      <div class="font-size-12 line-height-120">
        <span>{{ userInfo.phone }}</span>
      </div>
      <div class="font-size-12 line-height-120">
        <span>{{ userInfo.email }}</span>
      </div>
    </div>
    <div
      class="orderList"
      :class="[orderList && orderList.length > 0 ? '' : 'emptyList']"
    >
      <div v-if="orderList && orderList.length > 0">
        <q-infinite-scroll
          :offset="300"
          :scroll-target="$refs.pageRef"
          @load="onLoad"
        >
          <template v-for="item in orderList">
            <OrderCard :key="item.orderId" :order-detail="item" />
          </template>
          <template #loading>
            <div class="row justify-center q-my-xs">
              <q-spinner-dots color="primary" size="40px" />
            </div>
          </template>
        </q-infinite-scroll>
      </div>
      <div v-else class="flex justify-center items-center">
        <div class="text-center">
          <q-img
            src="~assets/images/Empty.png"
            spinner-color="white"
            style="height: 100px; max-width: 100px"
          />
          <div class="font-size-16 text-theme-gray-300 q-mt-sm">
            {{ $t('profile.noOrderListTip') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOrderHistory } from 'src/api/user.js';
import OrderCard from './components/OrderCard.vue';

export default {
  components: {
    OrderCard,
  },
  data() {
    return {
      orderList: [],
    };
  },
  mounted() {
    const params = {
      viewIndex: 1,
      viewSize: 8,
    };
    getOrderHistory(params).then((res) => {
      this.orderList = res?.data ?? [];
    });
  },
  methods: {
    onLoad(index, done) {
      const params = {
        viewIndex: index + 1,
        viewSize: 8,
      };
      getOrderHistory(params).then((res) => {
        if (res?.data?.length > 0) {
          this.orderList = [...this.orderList, ...res.data];
          done();
        } else {
          done(true);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.orderHistory {
  height: 100%;
  overflow: auto;
  padding-top: 64px;
  display: flex;
  flex-direction: column;
  .userInfo {
    color: #9ca3af;
    padding: 16px;
  }
  .orderList {
    padding-bottom: 48px;
    flex: 1;
  }
  .emptyList {
    background: #f9fafb;
    padding-top: 64px;
  }
}
</style>
